import axios from 'axios';
//import { store } from '../store';
//import { logout } from '../store/slices/authSlice';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.palabradevida.ru/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Interceptor para agregar token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      //store.dispatch(logout());
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Servicios específicos
export const authService = {
  register: (data: any) => api.post('/register', data),
  login: (data: any) => api.post('/login', data),
  logout: () => api.post('/logout'),
  verifyEmail: (token: string) => api.get(`/verify-email/${token}`),
  verifyPhone: (data: any) => api.post('/verify-phone', data),
  getProfile: () => api.get('/user')
};

export const studentService = {
  getAll: (params?: any) => api.get('/students', { params }),
  getById: (id: number) => api.get(`/students/${id}`),
  create: (data: any) => api.post('/students', data),
  update: (id: number, data: any) => api.put(`/students/${id}`, data),
  delete: (id: number) => api.delete(`/students/${id}`),
  getPayments: (id: number) => api.get(`/students/${id}/payments`),
  getPaymentStatus: (id: number, month: string, year: number) => 
    api.get(`/students/${id}/payment-status/${month}/${year}`)
};

export const parentService = {
  getAll: (params?: any) => api.get('/parents', { params }),
  getById: (id: number) => api.get(`/parents/${id}`),
  create: (data: any) => api.post('/parents', data),
  update: (id: number, data: any) => api.put(`/parents/${id}`, data),
  delete: (id: number) => api.delete(`/parents/${id}`),
  getStudents: (id: number) => api.get(`/parents/${id}/students`),
  getPendingApproval: () => api.post('/parents/pending-approval'),
  approveParent: (userId: number) => api.post(`/parents/${userId}/approve`),
  getPaymentHistory: (id: number) => api.get(`/parents/${id}/payments`)
};

export const teacherService = {
  getAll: (params?: any) => api.get('/teachers', { params }),
  getById: (id: number) => api.get(`/teachers/${id}`),
  create: (data: any) => api.post('/teachers', data),
  update: (id: number, data: any) => api.put(`/teachers/${id}`, data),
  delete: (id: number) => api.delete(`/teachers/${id}`),
  deactivate: (id: number) => api.post(`/teachers/${id}/deactivate`),
  activate: (id: number) => api.post(`/teachers/${id}/activate`),
  getPayments: (id: number) => api.get(`/teachers/${id}/payments`),
  getPaymentSummary: (id: number, params?: any) => api.get(`/teachers/${id}/payment-summary`, { params }),
  calculateSalary: (id: number, data: any) => 
    api.post(`/teachers/${id}/calculate-salary`, data),
  bulkUpdateRates: (data: any) => api.post('/teachers/bulk-update-rates', data)
};

export const paymentService = {
  // Monthly Payments
  getAllMonthly: (params?: any) => api.get('/monthly-payments', { params }),
  createMonthly: (data: any) => api.post('/monthly-payments', data),
  updateMonthly: (id: number, data: any) => api.put(`/monthly-payments/${id}`, data),
  deleteMonthly: (id: number) => api.delete(`/monthly-payments/${id}`),
  bulkUpload: (data: any) => api.post('/monthly-payments/bulk-upload', data),
  getMonthlySummary: (month: string, year: number) => 
    api.get(`/monthly-payments/summary/${month}/${year}`),
  getStudentsWithoutPayment: (months?: number) => 
    api.get(`/monthly-payments/students-without/${months || 2}`),
  
  // Teacher Payments
  //getAllTeacherPayments: (params?: any) => api.get('/teacher-payments', { params }),
  //createTeacherPayment: (data: any) => api.post('/teacher-payments', data),
  //updateTeacherPayment: (id: number, data: any) => api.put(`/teacher-payments/${id}`, data),
  //deleteTeacherPayment: (id: number) => api.delete(`/teacher-payments/${id}`),
  markAsPaid: (id: number) => api.post(`/teacher-payments/${id}/mark-paid`),
  //bulkCreateTeacherPayments: (data: any) => api.post('/teacher-payments/bulk-create', data),
  //getTeacherMonthlySummary: (month: string, year: number) => 
  //  api.get(`/teacher-payments/summary/${month}/${year}`),
  getMonthlyPayment: (id: number) => api.get(`/monthly-payments/${id}`),
  markMpAsPaid: (id: number) => api.post(`/monthly-payments/${id}/mark-paid`),
  getStudentPaymentSummary: (studentId: number) => 
    api.get(`/students/${studentId}/payment-summary`)
};


/*export const expenseService = {
  getAll: (params?: any) => api.get('/expenses', { params }),
  create: (data: any) => api.post('/expenses', data),
  update: (id: number, data: any) => api.put(`/expenses/${id}`, data),
  delete: (id: number) => api.delete(`/expenses/${id}`),
  getSummaryByType: (params?: any) => api.get('/expenses/summary-by-type', { params }),
  getMonthlyTrend: (params?: any) => api.get('/expenses/monthly-trend', { params }),
  getTopExpenses: (params?: any) => api.get('/expenses/top-expenses', { params }),
  importFromBank: (data: any) => api.post('/expenses/import-bank', data)
};*/

export const reportService = {
  getStudentsWithoutPayment: (params?: any) => 
    api.get('/reports/students-without-payment', { params }),
  getMonthlySummary: (params?: any) => api.get('/reports/monthly-summary', { params }),
  getTeacherPaymentsSummary: (params?: any) => 
    api.get('/reports/teacher-payments-summary', { params }),
  getExpensesSummary: (params?: any) => api.get('/reports/expenses-summary', { params }),
  getBalanceSheet: (params?: any) => api.get('/reports/balance-sheet', { params }),
  getUpcomingBajas: (params?: any) => api.get('/reports/upcoming-bajas', { params })
};

export const importService = {
  importExcel: (file: File) => {
    const formData = new FormData();
    formData.append('excel_file', file);
    return api.post('/import/excel', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  importBankExtract: (file: File) => {
    const formData = new FormData();
    formData.append('excel_file', file);
    formData.append('sheet_name', 'bank extracto');
    return api.post('/import/bank-extract', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};

export default api;